var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('navbar',{attrs:{"hideNavLogins":false}}),_vm._v(" "),_c('div',{staticClass:"container is-fullheight hero-body"},[_c('div',{staticClass:"columns is-centered"},[_c('div',{staticClass:"column is-12"},[_c('book-details',{ref:"book"})],1)])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5934f5fe","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/BookDetailsPage.vue
// module id = null
// module chunks = 